<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">病患列表</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <div style="padding-left: 10px;">
          <el-button type="primary" plain @click.native="toggleModalSelectAdd">添加</el-button>
<!--          <div style="float:right">-->
<!--            <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>-->
<!--            <el-button type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>-->
<!--          </div>-->
          <div style="clear:both;"></div>
        </div>

        <el-row style="margin-top:10px">
          <el-col :span="24">
            <el-table :data="elderlyInfo" ref="tableElderlyRel" style="width: 100%" border :height="300">
              <el-table-column label="姓名" prop="name" width="100"></el-table-column>
              <el-table-column label="手机号" prop="phone"></el-table-column>
              <el-table-column label="身份证号" prop="idCard"></el-table-column>
              <el-table-column label="地址" prop="homeAddress" ></el-table-column>

              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click.native.prevent="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
        </el-row>

        <div class="page">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

    <ElderlySelect ref="myElderlySelect" v-show="showModalSelectAdd"
                   v-on:closeSelectAdd="closeSelectAdd" v-on:getList="getList"></ElderlySelect>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import ElderlySelect from "./ElderlySelect";

export default {
  name: 'ElderlyRel',
  props:[],
  data() {
    return {
      showModalSelectAdd:false,

      name:'',

      loading: false,
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      medicinerCode:'',

    }
  },
  components:{ElderlySelect},
  methods: {

    toggleModalSelectAdd(){
      this.showModalSelectAdd = !this.showModalSelectAdd;
      this.$refs.myElderlySelect.init(this.medicinerCode);
    },
    closeSelectAdd(){
      this.showModalSelectAdd = !this.showModalSelectAdd;
    },

    init(medicinerCode){
      this.medicinerCode = medicinerCode;
      this.getElderly()
    },
    closeSelf() {
      this.$emit("closeElderlyEdit");
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getElderly();
    },

    getList(){
      this.getElderly();
    },

    getElderly(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Mediciner/ElderlyPageIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          medicinerCode:this.medicinerCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.elderlyInfo=response.data.data.pageInfo.list;
              this.totalItems = response.data.data.pageInfo.total;

              this.$nextTick(()=>{
                this.$refs.tableElderlyRel.doLayout();
              });

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          })
    },

    handleDelete(index,row){
      console.log(index,row);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Mediciner/DeleteElderlyRel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          medicinerCode:this.medicinerCode,
          listMedicinerElderlyRelCode:[row.medicinerElderlyRelCode],
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.$message.info("删除成功");

          this.getElderly();

        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })

    }

  }
}


</script>


